<div class="tw-flex tw-items-center">
  <input
    type="checkbox"
    class="hmm-checkbox"
    [formControl]="formControl"
    [formlyAttributes]="field"
  />
</div>
